// Client helpers that call the Cloudflare Pages Functions.

export async function geocode(query, countries) {
  const params = new URLSearchParams({ q: query });
  if (countries?.length) params.set('countries', countries.join(','));
  const res = await fetch(`/api/geocode?${params}`);
  if (!res.ok) throw new Error(`Geocoding failed: ${res.status} ${await safeText(res)}`);
  const data = await res.json();
  if (!data.features?.length) throw new Error(`No geocoding result for "${query}"`);
  const f = data.features[0];
  return {
    lon: f.geometry.coordinates[0],
    lat: f.geometry.coordinates[1],
    label: f.properties.label || f.properties.name || query
  };
}

async function safeText(res) {
  try { return (await res.text()).slice(0, 200); } catch { return ''; }
}
